import React, {useEffect, useState} from "react";
import Router from "../Components/Router";
import GlobalStyles from "../Components/GlobalStyles";

function App(location) {
  return (
    <div className="App-default">
      <Router />
      <GlobalStyles />
    </div>
  );
}

export default App;
